var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-twitter",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter-6",
    transform: "translate(2.000000, 10.000000)",
    fill: "#1DA1F2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1344939,80.4878049 C68.4947195,80.4878049 88.9257439,49.5249512 88.9257439,22.6750244 C88.9257439,21.7956951 88.9078354,20.9203902 88.8681951,20.0487073 C92.843627,17.1711032 96.2745149,13.6081637 99,9.52693902 C95.3605427,11.1455488 91.4442073,12.2349512 87.3357073,12.726128 C91.5293232,10.2106829 94.7486341,6.23116463 96.2676402,1.48761585 C92.2804312,3.85374468 87.9185044,5.52174037 83.369872,6.41970732 C79.6634085,2.47017073 74.386628,3.57437657e-15 68.5436159,3.57437657e-15 C57.3268354,3.57437657e-15 48.2309085,9.09954878 48.2309085,20.316128 C48.2309085,21.9107927 48.4093902,23.4613902 48.7579024,24.9492073 C31.8765915,24.0994573 16.9074695,16.0140549 6.88935366,3.7197439 C5.08499628,6.82061337 4.13593394,10.3448093 4.13908537,13.932439 C4.13908537,20.9819634 7.72481707,27.2050793 13.1778659,30.8459451 C9.95232022,30.7473975 6.79758359,29.8758356 3.97891463,28.3045427 C3.97589634,28.3898598 3.97589634,28.4729634 3.97589634,28.5641159 C3.97589634,38.4043537 10.977128,46.6203476 20.2710549,48.4820305 C18.5255303,48.9575812 16.7243395,49.1980152 14.9151951,49.1969634 C13.6086768,49.1969634 12.3353598,49.0683841 11.0978598,48.8307439 C13.6837317,56.9040732 21.1819756,62.7790793 30.0720549,62.9432744 C23.120122,68.3941098 14.3628476,71.6407866 4.84496341,71.6407866 C3.22584913,71.6421645 1.60805942,71.5481663 -8.58269248e-15,71.3592805 C8.98928049,77.1232134 19.6631707,80.4863963 31.1355,80.4863963",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTwitter);
export default __webpack_public_path__ + "static/media/logo-twitter.3b7a9ddc8117a81a5abf228280830fbb.svg";
export { ForwardRef as ReactComponent };